import { render } from "./user_avatar.vue?vue&type=template&id=2b8945eb"
import script from "./user_avatar.js?vue&type=script&lang=js&external"
export * from "./user_avatar.js?vue&type=script&lang=js&external"

import "./user_avatar.vue?vue&type=style&index=0&id=2b8945eb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__